"use strict";

exports.__esModule = true;
exports.Checkbox = Checkbox;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function Checkbox(props) {
  var checked = props.checked;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: _core.Classes.CONTROL_INDICATOR
  }, checked ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.SMALL_TICK
  }) : /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.BLANK
  }));
}